import React, { useContext, useEffect } from "react";
import Filters from "./Filters";
import logo from 'url:../images/logo.svg';
import {sendEvent} from '../events/events';
import { useNavigate  } from 'react-router-dom';
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../store/rootStore";


const Header:React.FC = observer(() => {

  const rootStore = useContext(RootStoreContext);
  const {filterPanelShown, toggleFilterPanelState} = rootStore.filterPanelStore;
  const {subjectType} = rootStore.wallSettingsStore;
  const {ccSetShowFilter, ccSetSearch, ccSearch} = rootStore.coCurricularStore;

  const navigate = useNavigate();

  const changeSubjectType = (e) => {
    switch(e.currentTarget.value) {
      case "subject":
        navigate("/curriculum/subjects");
        break;
      case "specialistModule":
        navigate("/curriculum/specialist-modules");
        break;    
      case "co-curricular":
        navigate("/curriculum/co-curricular");
        break;               
    }
  }


  return (
    <header>
      <div className='header__top'>
        <img src={logo} alt='Dollar Academy shield logo.' />
        <h1>The Dollar Academy Curriculum</h1>
        <div className='header__buttons'>
          {subjectType!=='co-curricular' ?
            <button className={`header__show-filters ` + (filterPanelShown ? 'chosen' : '')} onClick={() => toggleFilterPanelState()}>Filter wall <i className="fa-solid fa-arrow-down-a-z"></i></button>
            :
            null
          }     

          {subjectType==='co-curricular' ?
            <>
              <button className={`header__show-filters ` + (filterPanelShown ? 'chosen' : '')} onClick={() => ccSetShowFilter('cc')}>Filter wall <i className="fa-solid fa-arrow-down-a-z"></i></button>
              <input placeholder='Search...' value={ccSearch} onChange={(e) => ccSetSearch(e.currentTarget.value)} />
            </>
            : null
          }

          <div className='header__top-type-select'>
            <select onChange={(e) => changeSubjectType(e)} value={subjectType}>
              <option value='subject'>Subjects</option>
              <option value='specialistModule'>Specialist Modules</option>
              <option value='co-curricular'>Co-curricular</option>
            </select>
          </div>

        </div>

        {subjectType!=='co-curricular' ?
          <div className='header__scroll-buttons'>
            <button onClick={() => sendEvent('scrollWallLeft')} className='header__scroll-buttons-left'><i className="fa-solid fa-chevron-left"></i></button>
            <button onClick={() => sendEvent('scrollWallRight')} className='header__scroll-buttons-right'><i className="fa-solid fa-chevron-right"></i></button>
          </div>
          : null
        }
        
      </div>
      <Filters />
    </header>
  )
});

export default Header;
